import { Fragment } from 'preact';
import { useContext, useCallback } from 'preact/hooks';
import PropTypes from 'prop-types';

import '../scss/components/_agree-terms.scss';

import { createPortal } from 'preact/compat';
import TermsModal from '../modals/terms-modals/terms-modal';
import PrivacyModal from '../modals/privacy-modals/privacy-modal';

import StoreContext from '../helpers/context';

import { updateAgreedToTerms, updateModalsView } from '../store/dispatch-actions';

import { GCheckboxCheckedIcon, AWDCheckedIcon, AestheticImageBottom } from '../app/icons/common-icons';
import getSessionInfo from '../helpers/session-Info';
import {
  isAdaptiveuBrand, isINCHBrand, isAnytimeBrand, isServiceForgeCABrand,
  isAnsweringServiceBrand,
  isHellosellsBrand,
  isLexCABrand,
  isLexReceptionUKBrand,
  isSignMoreBrand,
  AWDSupported,
  isListerPlaceUKBrand,
  isChatSupportBrand,
  isSetmoreStartNowPage,
  isAnswerConnectBrand,
} from '../helpers/brands';
import { SuspenseWrapper } from '../helpers/dynamic-import-helper';

const { brand: { name } } = getSessionInfo();

export default function TermsSection({
  onCancel, onSubmit, btnText,
}) {
  const { state, dispatch } = useContext(StoreContext);

  const isHIPAA = !!state?.planDetails?.isHIPAA;

  const resetModalView = useCallback(() => {
    dispatch(updateModalsView({ editPlan: state.modalToBeShown?.editPlan }));
  });

  const showTermsModal = useCallback(() => {
    dispatch(updateModalsView({ view: 'terms' }));
  });

  const showPrivacyModal = useCallback(() => {
    dispatch(updateModalsView({ view: 'privacy' }));
  });

  const toggleAgreedToTerms = useCallback(() => {
    dispatch(updateAgreedToTerms({
      agreed: !state.agreedToTerms.agreed,
      showToolTip: state.agreedToTerms.showToolTip,
    }));
  }, [state.agreedToTerms.agreed]);

  return (
    <Fragment>
      <div className={`agree-terms  clearfix ${isLexReceptionUKBrand ? 'mb-8' : 'mb-10'}`}>
        {!isChatSupportBrand
        && !isSetmoreStartNowPage()
        && (AWDSupported ? (
          <button
            data-testid="agreeTermsBtn"
            onClick={toggleAgreedToTerms}
            className={`awd-checkbox ${
              state.agreedToTerms.showToolTip ? 'awd-checkbox--error' : ''
            } ${state.agreedToTerms.agreed ? 'awd-checkbox--checked' : ''}`}
          >
            <AWDCheckedIcon />
          </button>
        ) : (
          <button
            data-testid="agreeTermsBtn"
            onClick={toggleAgreedToTerms}
            className={`g-checkbox ${
              state.agreedToTerms.showToolTip ? 'error' : ''
            } ${state.agreedToTerms.agreed ? 'g-checkbox-checked' : ''}`}
          >
            <GCheckboxCheckedIcon />
          </button>
        ))}
        <TermsSectionContent
          showTermsModal={showTermsModal}
          showPrivacyModal={showPrivacyModal}
          btnText={btnText}
          selectedPlanId={state.planDetails.selectedPlanId}
            isFreeTrial={state?.planDetails?.freeTrial}
            />
      </div>
      {!isSetmoreStartNowPage() && (
        <>
          {(isAnswerConnectBrand) && <AestheticImageBottom />}
          <div
          className={`button-hold ${isAnytimeBrand ? 'fx fx-wrap' : ''} ${
            isAnsweringServiceBrand || isINCHBrand ? '' : 'ta-right'
          } ${
            isHellosellsBrand
            || isLexCABrand
            || isLexReceptionUKBrand
            || isSignMoreBrand
            || isListerPlaceUKBrand
              ? 'ta-right'
              : ''
          }`}
        >
            {!isAnsweringServiceBrand && !isINCHBrand && !isChatSupportBrand && (
              <button
               id='cancel-btn'
              data-testid="cancel"
              onClick={onCancel}
              className={`${
                isAnytimeBrand ? 'g-btn-negative' : 'g-btn-secondary '
              } mr-4`}
            >
                Cancel
              </button>
            )}
            {AWDSupported ? (
              <button
              data-testid="submit"
              id="submit-btn"
              type='submit'
              onClick={onSubmit}
              className={`awd-btn awd-btn-primary awd-btn--lg ${
                state.loader ? 'awd-activity-indicator' : ''
              }`}
            >
                <span className="awd-btn-label">{btnText}</span>
              </button>
            ) : (
              <button
              data-testid="submit"
               id="submit-btn"
              type='submit'
              onClick={onSubmit}
              className={`g-btn-primary ${
                state.loader ? 'g-btn-processing' : ''
              }`}
            >
                { btnText }
              </button>
            )}
            {isINCHBrand && (
              <button
              id='cancel-btn'
              data-testid="cancel"
              onClick={onCancel}
              className="g-btn-secondary ml-5"
            >
                Cancel
              </button>
            )}
          </div>
        </>
      )}
      {(state.modalToBeShown.view === 'terms'
      || state.modalToBeShown.view === 'hipaaTerms') && (
        <SuspenseWrapper>
          {createPortal(
            <TermsModal
              onClose={resetModalView}
              isHIPAA={state.modalToBeShown.view === 'hipaaTerms' || isHIPAA}
            />,
            document.getElementById('modal-wrapper'),
          )}
        </SuspenseWrapper>
      )}
      {state.modalToBeShown.view === 'privacy' && (
        <PrivacyModal onClose={resetModalView} />
      )}
    </Fragment>
  );
}

function TermsSectionContent({
  btnText, showTermsModal, showPrivacyModal, selectedPlanId, isFreeTrial,
}) {
  if (isAdaptiveuBrand) {
    return (
      <p className="agree-terms-text" data-testid='adaptiveUTermsContent'>Your use of AdaptiveU is governed by our <button type="button" data-testid="terms" className="nostyle fw-medium" onClick={showTermsModal}>terms of service</button>, to which you&apos;ll agree by using our services. {selectedPlanId ? ' After clicking the "Pay now" button, you\'ll receive an email that\'ll allow you to activate your AdaptiveU account.' : ''}</p>
    );
  }

  if (isLexReceptionUKBrand) {
    return (
      <p className="agree-terms-text" data-testid='lexukTermsContent'>
        Your use of LEX Reception is governed by our terms of service, to which you&rsquo;ll agree by checking the box to the left and by using our services. You can access the <button type="button" data-testid="terms" className="nostyle" onClick={showTermsModal}>terms of service here</button>. After checking the box to the left and clicking the &ldquo;Pay Now&rdquo; button, you&rsquo;ll receive an email that&rsquo;ll allow you to activate your LEX Reception account.
      </p>
    );
  }

  if (isFreeTrial && isAnswerConnectBrand) {
    return (
      <><p className="agree-terms-text" data-testid='freetrailACTermsContent'>Your use of {name} is governed by our terms of service, to which<br className='phone-hide' /> you&apos;ll agree by checking the box to the left and by using our services. You can access the <button type="button" data-testid="terms" className="nostyle fw-medium tc-action" onClick={showTermsModal}>terms of service</button> here. After checking the box to the left and clicking the &quot;Start free trial&quot; button, you&apos;ll receive an email that&apos;ll allow you to activate your {name} account.</p><p className='agree-terms-text pl-7 mt-3'>*Once you have used either your 150 free minutes or reached the 14-day trial period, whichever comes first, your billing cycle will commence based on your chosen plan value. You may cancel at any time; however, upon cancellation, your account will be immediately deactivated.</p></>
    );
  }

  if (isAnsweringServiceBrand && !isListerPlaceUKBrand) {
    return (
      <p className="agree-terms-text">Your use of {name} is governed by our terms of service, to which<br className='phone-hide'/> you&apos;ll agree by checking the box to the left and by using our services. You can access the <button type="button" data-testid="terms" className="nostyle fw-medium tc-action" onClick={showTermsModal}>terms of service</button> here. After checking the box to the left and clicking the &quot;Pay Now&quot; button, you&apos;ll receive an email that&apos;ll allow you to activate your {name} account.</p>
    );
  }

  if (isAnytimeBrand) {
    return (
      <p className="agree-terms-text">By signing up, you agree to our <button type="button" data-testid="terms" className="nostyle tc-action" onClick={showTermsModal}>Terms of Use</button> & <button type="button" data-testid="privacy" className="nostyle tc-action" onClick={showPrivacyModal}>Privacy Policy</button>. After clicking &apos;{btnText}&apos;, you&apos;ll be directed to your{' '} <span className="tt-caps">{name}</span> account.</p>
    );
  }

  if (isHellosellsBrand) {
    return (
      <p className="agree-terms-text">Your use of HelloSells is governed by our terms of service, to which you&apos;ll agree by checking the box to the left and by using our services. You can access the <button type="button" data-testid="terms" className="nostyle fw-medium" onClick={showTermsModal}>terms of service</button> here.After checking the box to the left and clicking the &quot;{btnText}&quot; button, you&apos;ll receive an email that&apos;ll allow you to activate your HelloSells account.</p>
    );
  }

  if (isSignMoreBrand) {
    return (
      <p className="agree-terms-text">Your use of SignMore is governed by our terms of service, to which you&apos;ll agree by checking the box to the left and by using our services. You can access the <button type="button" data-testid="terms" className="nostyle fw-medium" onClick={showTermsModal}>terms of service</button> here.After checking the box to the left and clicking the &quot;{btnText}&quot; button, you&apos;ll receive an email that&apos;ll allow you to activate your HelloSells account.</p>
    );
  }

  if (isChatSupportBrand) {
    return (
      <p className="agree-terms-text">By signing up, you agree to our <button type="button" data-testid="terms" className="nostyle tc-action" onClick={showTermsModal}>Terms of Use</button> and <button type="button" data-testid="privacy" className="nostyle tc-action" onClick={showPrivacyModal}>Privacy Policy</button>.</p>
    );
  }

  if (isServiceForgeCABrand) {
    return (
      <p className="agree-terms-text">Your use of ServiceForge is governed by our <button type="button" data-testid="terms" className="nostyle fw-medium" onClick={showTermsModal}>terms of service,</button> to which you&apos;ll agree by using our services. After clicking the &quot;{btnText}&quot; button, you&apos;ll receive an email to activate your ServiceForge account.</p>
    );
  }

  if (isListerPlaceUKBrand) {
    return (
      <p className="agree-terms-text" data-testid='lister-term-cont'>
        Your use of Lister Place is governed by our terms and conditions, to which you&apos;ll agree by checking the box to the left. You can access the terms and conditions <button type="button" data-testid="terms" className="nostyle fw-medium tc-blue" onClick={showTermsModal}>here</button>. After checking the box to the left and clicking the &quot;{btnText}&quot; button, you&apos;ll receive an email with your room details and the next steps.
      </p>
    );
  }

  if (isSetmoreStartNowPage()) {
    return (
      <p className="agree-terms-text" data-testid='setmoreTermsContent'>
        By signing in, you agree to our <button type="button" data-testid="terms" className="nostyle tc-action" onClick={showTermsModal}>Terms of Use</button> & <button type="button" data-testid="privacy" className="nostyle tc-action" onClick={showPrivacyModal}>Privacy Policy</button>.
      </p>
    );
  }

  return (
    <p className="agree-terms-text">By signing up, you agree to our <button type="button" data-testid="terms" className="nostyle tc-action" onClick={showTermsModal}>Terms of Use</button> & <button type="button" data-testid="privacy" className="nostyle tc-action" onClick={showPrivacyModal}>Privacy Policy</button>. After clicking the &quot;{btnText}&quot; button, you&apos;ll be redirected to your active{' '} <span className="tt-caps">{name}</span> account.</p>
  );
}

TermsSection.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  btnText: PropTypes.string,
};

TermsSection.defaultProps = {
  btnText: 'Pay Now',
};

TermsSectionContent.propTypes = {
  btnText: PropTypes.string,
  showTermsModal: PropTypes.func.isRequired,
  showPrivacyModal: PropTypes.func.isRequired,
  selectedPlanId: PropTypes.string,
  isFreeTrial: PropTypes.bool,
};

TermsSectionContent.defaultProps = {
  isFreeTrial: false,
};
